const getConfig = () => {
    const {
        nonce, jwtUrl, apiUrl, refreshUrl, photosUrl,
        configUrl, appHost, appPrefix, appName, customerSecret, customerKey, customerKeysRedirect, authError,
        loginUrl,
    } = window.promoVars;

    return {
        apiUrl,
        appHost,
        appPrefix,
        appName,
        authError,
        configUrl,
        customerKey,
        customerSecret,
        customerKeysRedirect,
        jwtUrl,
        nonce,
        photosUrl,
        refreshUrl,
        loginUrl,
    };
};

export default getConfig;
